import { useState } from "react";

import {
  ModalSubFeedbackContentNeutralComments,
  ModalSubFeedbackContentNeutralReasons,
  ModalSubFeedbackContentNeutralSummary,
  NeutralData,
  Step,
} from "~components/ModalSubFeedback";

type ModalSubFeedbackContentNeutralProps = {
  neutralData: NeutralData;
  onDismiss: () => void;
  onSubmit: (data: NeutralData) => void;
  setNeutralData: (neutralData: NeutralData) => void;
  setStep: (step: Step) => void;
  subName?: string;
  hasSubmissionError?: boolean;
};

export type NeutralStep = "reasons" | "comments" | "summary";

export function ModalSubFeedbackContentNeutral(props: ModalSubFeedbackContentNeutralProps) {
  const { neutralData, onDismiss, setNeutralData, setStep, subName, onSubmit, hasSubmissionError } =
    props;

  const [neutralStep, setNeutralStep] = useState<NeutralStep>("reasons");

  return (
    <>
      {neutralStep === "reasons" && (
        <ModalSubFeedbackContentNeutralReasons
          goBackToRatingStep={() => setStep("rating")}
          neutralData={neutralData}
          onDismiss={onDismiss}
          setNeutralData={setNeutralData}
          setNeutralStep={setNeutralStep}
          subName={subName}
        />
      )}
      {neutralStep === "comments" && (
        <ModalSubFeedbackContentNeutralComments
          neutralData={neutralData}
          onDismiss={onDismiss}
          setNeutralData={setNeutralData}
          setNeutralStep={setNeutralStep}
          onSubmit={onSubmit}
          hasSubmissionError={hasSubmissionError}
          subName={subName}
        />
      )}
      {neutralStep === "summary" && <ModalSubFeedbackContentNeutralSummary onDismiss={onDismiss} />}
    </>
  );
}
